import React, { useState, useEffect } from "react";
import { get } from "utils/requests";
import { apiToken } from "../../services/legit/token";

import { connect } from "react-redux";
import { RootState } from "StoreTypes";
import { RISK_API_ENDPOINT } from "common";
import styles from "./styles.module.scss";
import ApexTable from "apex-table-ts";
import { AUDIT_LOG_COLUMNS } from "./constants";

export interface Props {
  endpoint: string;
  token: string | null;
}

export interface AuditItem {
  item: string;
  action: string;
  request: string;
  performed_by: string;
  performed_at: string;
}
const AuditLogForm = ({ endpoint, token }: Props) => {
  const [auditLog, setAuditLog] = useState<AuditItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [headers, setHeaders] = useState(
    new Headers({
      "Content-Type": "application/json",
      Authorization: token as string,
    })
  );
  useEffect(() => {
    const endpoint = `${RISK_API_ENDPOINT}/log`;
    get(endpoint, headers)
      .then((results) => {
        setAuditLog(results.value);
        //loading
        // This is never called
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  }, [headers]);

  return (
    <div>
      <div className={styles.title}>
        <h2>Audit Log</h2>
        <h4>View changes made to threshold values</h4>
      </div>
      <div className={styles.table}>
        {auditLog.length > 0 && (
          <ApexTable
            enableColumnSort
            enableColumnFilters
            columns={AUDIT_LOG_COLUMNS}
            rows={auditLog}
            enableCsvExport
            csvLinkText={"Export to CSV"}
            csvFilename="threshold-auditlog.csv"
            height={600}
            // font awesome icons not working so setting to false
            enableSortIcons={false}
          />
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: apiToken(state),
});

export default connect(mapStateToProps)(AuditLogForm);
